<template>
  <div>
    <youtube resize fitParent :video-id="getId" ref="youtubePlayer" :player-vars="playerVars"></youtube>
  </div>
</template>

<script>
import VideosAPI from '@/api/videos-api'

export default {
  name: 'YoutubePlayer',
  props: {
    id: Number,
    ementaId: Number,
    tipoOrigemId: Number,
    urlVideo: String,
    inicio: Number
  },

  data () {
    return {
      player: null,
      playerVars: {
        modestbranding: 1
      },
      tempoTotalVideo: 0,
      tempoAtualVideo: 0
    }
  },

  beforeDestroy () {
    try {
      this.player.unload()
    } catch (error) {
      this.error = error
    }
    clearInterval(this.intervalId)
  },

  mounted () {
    this.player = this.$refs.youtubePlayer.player
    this.player.addEventListener('onStateChange', this.youtubeStateChange)
    this.intervalId = setInterval(() => {
      this.concluiVideo()
    }, 3000)
  },

  computed: {
    getId () {
      return this.$youtube.getIdFromUrl(this.urlVideo)
    },

    autoplay: function () {
      return JSON.parse(localStorage.getItem('autoplay'))
    },

    controleTopico: function () {
      return this.$store.getters.getControleTopico
    }
  },

  watch: {
    videoId: 'update'
  },

  methods: {
    update (videoId) {
      return this.player.loadVideo(videoId)
    },

    play: function () {
      this.player.seekTo(parseInt(this.inicio))
      this.player.playVideo()
    },

    youtubeStateChange (event) {
      if (event.data === 0) {
        VideosAPI.atualizarTempoVideo(this.ementaId, 0.1)
        this.autoplayVideo()
      }
      if (event.data === 2) {
        this.player.getCurrentTime().then(seconds => {
          if (this.inicio !== seconds) {
            VideosAPI.atualizarTempoVideo(this.ementaId, seconds)
          }
        })
      }
    },

    autoplayVideo () {
      if (this.autoplay) {
        window.eventBus.$emit('salvarAnotacao')
        window.eventBus.$on('anotacaoSalva', async () => {
          await this.$store.dispatch('iniciaTimer', 5)
          this.$router.push(this.controleTopico.proximo.url)
        })
      }
    },

    async concluiVideo () {
      this.tempoAtualVideo = await this.player.getCurrentTime()
      this.tempoTotalVideo = await this.player.getDuration()
      this.$store.dispatch('concluiEmentaVideo', { ementaId: this.ementaId, tempoAtual: this.tempoAtualVideo, tempoTotal: this.tempoTotalVideo })
    }
  }
}
</script>

<style scoped>

</style>
